import { createElement } from 'react';
import { Card } from '@alifd/next';
import './index.scss';
const OadpCardDivider = function OadpCardDivider({ inset, ...otherProps }) {
    return (createElement(Card.Divider, Object.assign({ inset: inset }, otherProps)));
};
export default OadpCardDivider;
